import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profili',
  templateUrl: './profili.component.html',
  styleUrls: ['./profili.component.css']
})
export class ProfiliComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
